import { useDispatch, useSelector } from 'react-redux';

import { RootState } from 'app/appStore';
import {
	IBrand,
	IJoinedInviteBrand,
	IJoinedInviteOffer,
	IJoinedOffer,
	IOpenedOffer,
	setJoinedBrand,
	setJoinedInviteBrand,
	setJoinedInviteOffer,
	setJoinedOffer,
	setJoinedSources,
	setOpenedModal,
	setOpenedOffer,
	TOpenedModal,
} from 'entities/Brand';

export const useBrandsSlice = () => {
	const dispatch = useDispatch();

	return {
		...useSelector((s: RootState) => s.brandsSlice),
		setJoinedBrand: (brand: IBrand | null) => dispatch(setJoinedBrand(brand)),
		setJoinedInviteBrand: (brand: IJoinedInviteBrand | null) => dispatch(setJoinedInviteBrand(brand)),
		setJoinedOffer: (offer: IJoinedOffer | null) => dispatch(setJoinedOffer(offer)),
		setJoinedInviteOffer: (offer: IJoinedInviteOffer | null) => dispatch(setJoinedInviteOffer(offer)),
		setOpenedOffer: (offer: IOpenedOffer | null) => dispatch(setOpenedOffer(offer)),
		setOpenedModal: (modal: TOpenedModal) => dispatch(setOpenedModal(modal)),
		setJoinedSources: (sources: string[] | null) => dispatch(setJoinedSources(sources)),
	};
};
